/*
 * @Author: zhao - 🍉
 * @Date: 2022-01-10 14:51:35
 * @LastEditTime: 2022-01-10 14:52:32
 * @LastEditors: zhao - 🍉
 * @Description: 平台对账 - 系统对账
 * @FilePath: /zhzj-admin/src/page/PlatformAccountingRecord/ReconciliationList/components/SystemCheck.jsx
 */
import { Form, message, Modal, Select } from 'antd';
import React, { useState, useRef } from 'react'
import DatePickerMoment from '../../../../components/DatePicker';
import { mapPlatformReconciliationSyncType } from "../../../../axios/dictionaries";
import { fetchPlatformRecordSynchronizeStatement } from '../../../../services/platformAccountingRecord';

const PlatformSystemCheckModal = (props) => {
    const [visible, setVisible] = useState(false);
    const [loading, setLoading] = useState(false);
    const [formData, setFormData] = useState({});
    let monitor = useRef(null)

    const open = () => {
        setVisible(true)
        return new Promise((resolve, reject) => {
            monitor.current = resolve
        })
    }
    const close = () => {
        setVisible(false)
    }

    const postSubmit = () => {
        setLoading(true)
        return fetchPlatformRecordSynchronizeStatement(formData).then(res => {
            message.success('同步成功')
        }).finally(() => {
            setLoading(false)
        })
    }

    const syncDataDisiabled = (date) => {
        if (formData.syncType === 1 && date.isSame(Date(),'d')) {
            return true
        }
        return !date.isBefore()
    }

    const handleChange = (data) => {
        setFormData({...formData, ...data})
    }

    const handleSubmit = () => {
        
        if (!formData.syncType) return message.warning('请选择同步类型')
        if (!formData.syncDate) return message.warning('请选择同步日期')
        postSubmit().then(() => {
            close()
            monitor.current()
        })
    }

    props.getRef && props.getRef({ open })
    
    return (
        <Modal title="系统对账" visible={visible} onCancel={close} onOk={handleSubmit} confirmLoading={loading} >
            <Form layout="vertical" style={{ padding: 20 }}>
                <Form.Item label="同步类型">
                    <Select value={formData.syncType} placeholder="请选择同步类型" onChange={e => handleChange({ syncType: e, syncDate: null })}>
                        {mapPlatformReconciliationSyncType.map(e => <Select.Option key={e.value} value={e.value}>{e.title}</Select.Option>)}
                    </Select>
                </Form.Item>
                <Form.Item label="同步日期">
                    <DatePickerMoment disabledDate={syncDataDisiabled} value={formData.syncDate} style={{width: '100%'}} onChange={(e, dateString) => handleChange({ syncDate: dateString })} />
                </Form.Item>
            </Form>
        </Modal>
    )
}

export default PlatformSystemCheckModal


// WEBPACK FOOTER //
// ./src/page/PlatformAccountingRecord/ReconciliationList/components/SystemCheck.jsx